/* @__PURE__ */ (function(OneRouter2) {
})(OneRouter || (OneRouter = {}));
var OneRouter;
export {
  OneRouter
};
//# sourceMappingURL=router.js.map
